import { Component } from '@angular/core';
import { SpinnerService } from '@core/services/spinner.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { SpinnerElementComponent } from '../spinner-element/spinner-element.component';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
	// tslint:disable-next-line: component-selector
	selector: 'rx-spinner',
	template: '<rx-spinner-element *ngIf="(active$ | async)"></rx-spinner-element>',
	standalone: true,
	imports: [NgIf, SpinnerElementComponent, AsyncPipe]
})
export class SpinnerComponent {
	active$: Observable<boolean> = this.spinner.onActiveChanged$.pipe(distinctUntilChanged());

	constructor(private readonly spinner: SpinnerService) {}
}
